<!-- Modal Backdrop -->
<div
  class="modal fade"
  [class.show]="isOpen()"
  [style.display]="isOpen() ? 'block' : 'none'"
  tabindex="-1"
  role="dialog"
  aria-modal="true"
  (click)="onBackdropClick($event)"
  (keydown)="onKeydown($event)"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title d-flex align-items-center gap-2">
          <i *ngIf="config.icon" class="bi" [ngClass]="config.icon"></i>
          {{ config.title }}
        </h5>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="close()"
          [disabled]="isProcessing()"
        ></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <p class="mb-0">{{ config.message }}</p>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-secondary"
          (click)="close()"
          [disabled]="isProcessing()"
        >
          {{ config.cancelText || 'Cancel' }}
        </button>
        <button
          type="button"
          class="btn"
          [ngClass]="config.confirmButtonClass || 'btn-primary'"
          (click)="confirm()"
          [disabled]="isProcessing()"
        >
          <span *ngIf="isProcessing()" class="spinner-border spinner-border-sm me-1" role="status"></span>
          {{ config.confirmText || 'Confirm' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Backdrop Overlay -->
<div
  class="modal-backdrop fade"
  [class.show]="isOpen()"
  *ngIf="isOpen()"
></div>
